import Head from "next/head";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import { useRouter } from "next/router";
import axios from "axios";
import config from "../../../config";
import cookie from "js-cookie";
import { Button, Form, Modal } from "react-bootstrap";
import { ImageList } from "../../../src/components/design-pages/imageList";

const tileData = [
  {
    src: "https://images.orientbell.com/media/design-images/kitchen/Open Kitchen/Open Kitchen Design with White Cabinets & Tiles.webp",
    alt: "Modern open kitchen design with white cabinets, patterned wall tiles, and a sleek cooking space.",
    title: "Open Kitchen Design with White Cabinets & Tiles",
  },
  {
    src: "https://images.orientbell.com/media/design-images/kitchen/Open Kitchen/Stylish open kitchen design with grey cabinets.webp",
    alt: "Stylish open kitchen design with grey cabinets, patterned backsplash tiles, and a modern dining area.",
    title: "Stylish Open Kitchen Design with Grey Cabinets",
  },
  {
    src: "https://images.orientbell.com/media/design-images/kitchen/Open Kitchen/Open kitchen design with wooden island.webp",
    alt: "Open kitchen design with a wooden island, marble-style tiles, pendant lighting, and stylish seating.",
    title: "Open Kitchen Design with Wooden Island",
  },
  {
    src: "https://images.orientbell.com/media/design-images/kitchen/Open Kitchen/Elegant Open Kitchen design with Blue Backsplash.webp",
    alt: "Elegant open kitchen design with grey cabinets, blue mosaic backsplash, and white tiled walls.",
    title: "Elegant Open Kitchen Design with Blue Backsplash",
  },
  {
    src: "https://images.orientbell.com/media/design-images/kitchen/Open Kitchen/Stylish Open Kitchen Design with Hexagonal Backsplash.webp",
    alt: "Stylish open kitchen design with dark cabinets, marble walls, hexagonal backsplash, and modern appliances.",
    title: "Stylish Open Kitchen Design with Hexagonal Backsplash",
  },
  {
    src: "https://images.orientbell.com/media/design-images/kitchen/Open Kitchen/Modern Open Kitchen Design with decorative tiles.webp",
    alt: "Modern open kitchen design with white cabinets, warm wooden countertops, and decorative accent tiles.",
    title: "Modern Open Kitchen Design with Decorative Tiles",
  },
  {
    src: "https://images.orientbell.com/media/design-images/kitchen/Open Kitchen/Open Kitchen Design with Tea Set Tiles.webp",
    alt: "Open kitchen design with light blue cabinets, sleek countertops, wall shelves, and decorative tea set tile accents.",
    title: "Open Kitchen Design with Tea Set Tiles",
  },
  {
    src: "https://images.orientbell.com/media/design-images/kitchen/Open Kitchen/Sleek Open Kitchen Design with black flooring.webp",
    alt: "A sleek open kitchen design with gray cabinets, modern island, textured backsplash, and glossy black flooring.",
    title: "Sleek Open Kitchen Design with Black Flooring",
  },
  {
    src: "https://images.orientbell.com/media/design-images/kitchen/Open Kitchen/modern open kitchen design with wooden cabinets.webp",
    alt: "A modern open kitchen design with wooden cabinets and tiled walls.",
    title: "Modern Open Kitchen Design with Wooden Cabinets",
  },
  {
    src: "https://images.orientbell.com/media/design-images/kitchen/Open Kitchen/Stunning Open Kitchen Design with white patterned tiles.webp",
    alt: "A stunning open kitchen design with wooden cabinets, white patterned tiles creating a modern look.",
    title: "Stunning Open Kitchen Design with White Patterned Tiles",
  },
  {
    src: "https://images.orientbell.com/media/design-images/kitchen/Open Kitchen/Stylish Open Kitchen Design with subway tile backsplash.webp",
    alt: "A stylish open kitchen design with white cabinets, subway tile backsplash, and a sleek modern finish.",
    title: "Stylish Open Kitchen Design with Subway Tile Backsplash",
  },
];
const text =
  "An open kitchen design creates a welcoming space that blends the kitchen with the living room or dining area. This kitchen design offers a fantastic way to make your home feel more spacious and connected. Whether you want a large island or prefer a more compact layout, it can allow you to be part of every conversation while cooking. With an open modular kitchen design, you can choose from modern, minimalist, or a variety of other styles to match your aesthetic and functional needs. No matter the style, this kitchen gives you more space for spending time with loved ones. Also, every open kitchen has customised storage options like cabinets and shelves for easy access to utensils and spices. Here are some open kitchen design ideas that you can consider to craft a smart, beautiful cooking area.";
const settings = {
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: true,
  centerMode: false,
  autoplaySpeed: 3000,
  arrows: true,
  dots: false,
  centerPadding: "0px",
  responsive: [
    {
      breakpoint: 991,
      settings: {
        arrows: true,
        centerMode: false,
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 768,
      settings: {
        arrows: true,
        centerMode: false,
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 641,
      settings: {
        arrows: true,
        centerMode: false,
        slidesToShow: 1,
      },
    },
  ],
};
const faqs = [
  {
    question: "What is an open kitchen style?",
    answer:
      "An open kitchen has a design where the cooking area is connected with the living or dining space, without any separating walls. This layout creates an uninterrupted flow. Moreover, it fosters social interaction and modern looks.",
  },
  {
    question: "Are open kitchen layouts a good choice?",
    answer:
      "Yes, open kitchen layouts are a great choice. They create a roomy look, improve ventilation, and make cooking more interactive by connecting the culinary area with other areas. Also, they allow for easier conversations with family and friends while preparing meals.",
  },
  {
    question: "What are some trendy open kitchen ideas?",
    answer:
      "Trendy open kitchen ideas feature sleek islands that work as dining spaces, minimalist handleless cabinets, and bold statement backsplashes with tiles. Incorporate neutral tones, biophilic elements like indoor plants, and industrial chic accents for a modern touch. Smart appliances, open shelving, and seamless integration with living spaces enhance functionality and style.",
  },
  {
    question: "How can I decorate my open kitchen?",
    answer:
      "To decorate your open kitchen, you can pick a cohesive colour scheme that complements your living area. Add a sleek granite tiled countertop and a bold tiled backsplash. Also, install an island for both function and charm. Use modern lighting and include storage units to keep the cooking area organised and refined.",
  },
];

function OpenKitchen() {
  const maxChars = 300;
  const previewText = text.substring(0, maxChars);
  const remainingText = text.substring(maxChars);

  const [isReadMore, setIsReadMore] = useState(false);
  const [isExpertTalkClicked, setIsExpertTalkClicked] = useState(false);
  const [activeIndex, setActiveIndex] = useState(null);
  const [relatedBlogData, setRelatedBlogData] = useState([]);
  const [showAll, setShowAll] = useState(false);

  const displayedFAQs = showAll ? faqs : faqs.slice(0, 5);

  var requestOptions = {
    method: "GET",
  };
  const getRelatedBlogs = async () => {
    fetch(
      `${config.HEADLESS_BASE_URL}/blog/wp-json/post/v2/category/term=kitchen-designs`,
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => {
        setRelatedBlogData(JSON.parse(result));
      })
      .catch((error) => console.log("error", error));
  };
  const handleToggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  useEffect(() => {
    getRelatedBlogs();
  }, []);

  return (
    <>
      <Head>
        <title>Open Kitchen Design Ideas | Orientbell </title>

        <meta name="title" content="Open Kitchen Design Ideas | Orientbell " />
        <meta
          name="description"
          content="Looking for Open Kitchen ideas? Orientbell offers creative ideas to craft warm, modern, and inviting kitchen spaces."
        />
      </Head>

      <div className="designpage-section">
        <div className="container">
          <Breadcrumb>
            <Breadcrumb.Item href="https://www.orientbell.com">
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item href="https://www.orientbell.com/design-ideas">
              Design Ideas
            </Breadcrumb.Item>
            <Breadcrumb.Item href="https://www.orientbell.com/design-ideas/kitchen-designs">
              Kitchen Designs
            </Breadcrumb.Item>
            <Breadcrumb.Item href="https://www.orientbell.com/design-ideas/kitchen-designs/open-kitchen">
              Open Kitchen
            </Breadcrumb.Item>
          </Breadcrumb>
          <div className="designpage-heading-bx padding-spacing">
            <h4>Showing {tileData.length} results for </h4>
            <h1>Open Kitchen Design</h1>
            <p className="description-text">
              {previewText}
              {!isReadMore && text.length > maxChars && "..."}
              {isReadMore && <span>{remainingText}</span>}
              {text.length > maxChars && (
                <button onClick={() => setIsReadMore(!isReadMore)}>
                  {isReadMore ? "Read Less" : "Read More"}
                </button>
              )}
            </p>
          </div>
          <div className="obl-master-design-section">
            <h2> Modern Open Kitchen Designs</h2>
            <div className="designpage-category-row inner-design-gallery">
              <ImageList tileData={tileData} />
            </div>

            <div className="bottom-content">
              <div className="common-text-content-section">
                <h2>Modern Open Kitchen Designs</h2>
                <p>
                  Modern open kitchen interior designs aim for a perfect blend
                  of style and functionality. Here are some tips to craft a
                  stunning open kitchen design.
                </p>
                <ul>
                  <li>
                    <h5>
                      <strong>Spacious Look:</strong>
                    </h5>
                    <p>
                      Most modern open kitchen design ideas focus on creating a
                      sense of space and openness. They are perfect for both
                      compact apartments and grandeur villas.
                    </p>
                  </li>
                  <li>
                    <h5>
                      <strong>Stylish Tiles:</strong>
                    </h5>
                    <p>
                      Pick beautiful glossy tiles to craft a stunning,
                      low-maintenance kitchen backsplash that draws attention.
                      Also, go for anti-skid or matte options in large sizes for
                      safe flooring. Consider laying the same floor tiles across
                      the open setting, be it dining or living room, creating a
                      seamless transition.
                    </p>
                  </li>
                  <li>
                    <h5>
                      <strong>Durable Countertops:</strong>
                    </h5>
                    <p>
                      {`Durable countertops can make your life easier. That's why
                      you should pick granite tiles in large sizes for a
                      countertop that needs minimal maintenance and offers
                      elegance and long-lasting performance.`}
                    </p>
                  </li>
                </ul>
              </div>

              <div className="common-text-content-section">
                <h2>Small Open Kitchen Designs</h2>
                <p>
                  Every Indian-style small open kitchen design focuses on adding
                  character that reflects homeowners’ personality. Here are some
                  ideas to craft an elegant open kitchen design for small
                  spaces.
                </p>
                <ul>
                  <li>
                    <h5>
                      <strong>Maximise Space:</strong>
                    </h5>
                    <p>
                      Every small open kitchen helps make the most of limited
                      space in modern apartments or small villas. It blends
                      style and functionality to craft an inviting cooking
                      space.
                    </p>
                  </li>
                  <li>
                    <h5>
                      <strong>Tiles:</strong>
                    </h5>
                    <p>
                      Combine tiles with vibrant tile patterns or unique
                      textures to add a cosy feel to your kitchen design.
                      Options like Moroccan, geometric, and floral are perfect
                      to elevate any beautiful kitchen backsplash. Opt for matte
                      or anti-skid flooring options, such as wooden or stone
                      tiles, to create a welcoming and safe interior design in
                      the open setting. Also, install durable granite tiles in
                      large sizes to craft a usable kitchen countertop.
                    </p>
                  </li>
                </ul>
              </div>

              <div className="common-text-content-section">
                <h2>Advantages Of An Open Kitchen Design</h2>
                <p>
                  Most Indian open kitchen designs offer several benefits, which
                  aim to elevate the cooking space and make life easier. Here
                  are some of these advantages that you should remember.
                </p>
                <ul>
                  <li>
                    <h5>
                      <strong>Stylish and Aesthetic:</strong>
                    </h5>
                    <p>
                      Every simple open kitchen design delivers a modern touch
                      to any home. With a well-chosen colour scheme and sleek
                      tile designs, the kitchen can be both beautiful and
                      functional. Also, since there is no wall to block the
                      airflow, an open kitchen allows for better ventilation.
                    </p>
                  </li>
                  <li>
                    <h5>
                      <strong>Maximised Floor Space:</strong>
                    </h5>
                    <p>
                      Without the partition of walls, you can get to use every
                      bit of floor space, providing enough room to move
                      conveniently. After all, maximising space is important,
                      and open layouts suit homes of all sizes.
                    </p>
                  </li>
                  <li>
                    <h5>
                      <strong>Smart Storage:</strong>
                    </h5>
                    <p>
                      Make sure you include cabinets and shelves in your open
                      kitchen, keeping everything accessible.
                    </p>
                  </li>
                </ul>
              </div>

              <div className="common-text-content-section">
                <h2>
                  Things To Consider While Planning An Open Kitchen Design
                </h2>
                <p>
                  A simple normal kitchen design makes cooking and entertaining
                  easier. Here are a few things to consider to craft an elegant
                  open kitchen design.
                </p>
                <ul>
                  <li>
                    <h5>
                      <strong>Aesthetic and Finishes:</strong>
                    </h5>
                    <p>
                      The aesthetic of every open kitchen design matters. Choose
                      vibrant or bold tile designs with glossy finishes for the
                      backsplash to add a modern touch. Pick larger granite
                      tiles for a beautiful countertop and kitchen island and
                      anti-skid tiles for the flooring.
                    </p>
                  </li>
                  <li>
                    <h5>
                      <strong>Noise and Smells:</strong>
                    </h5>
                    <p>
                      Consider ways to contain smells. This is because smoke
                      travels easily in open-plan spaces. Install an efficient
                      ventilation system to ensure the smell of food does not
                      linger around your home.
                    </p>
                  </li>
                  <li>
                    <h5>
                      <strong>Storage Needs:</strong>
                    </h5>
                    <p>
                      Any simple open kitchen interior design can look sleek
                      with sufficient storage. With cabinets and shelves
                      installed on walls, you can keep things organised.
                    </p>
                  </li>
                  <li>
                    <h5>
                      <strong>Connection with Living Area:</strong>
                    </h5>
                    <p>
                      An open kitchen can easily connect to the dining or living
                      room with a sofa and decor elements.
                    </p>
                  </li>
                </ul>
              </div>
            </div>

            <div className="designpage-faq-section padding-spacing">
              <h2>FAQs About Open Kitchen Design</h2>
              <div className="newacd designpage-faq-row">
                <ul className="accordion">
                  {displayedFAQs.map((faq, index) => (
                    <li key={index}>
                      <a className="toggle" onClick={() => handleToggle(index)}>
                        {index + 1}. {faq.question}
                      </a>
                      {activeIndex === index && (
                        <ul className="inner">
                          <li>{faq.answer}</li>
                        </ul>
                      )}
                    </li>
                  ))}
                </ul>
                {faqs.length > 5 && (
                  <div className="tru_btn_new design-page">
                    <button
                      className="btn btn-primary"
                      onClick={() => setShowAll(!showAll)}
                    >
                      {showAll ? "Show Less" : "Read More"}
                    </button>
                  </div>
                )}
              </div>
            </div>

            {relatedBlogData?.length > 0 && (
              <div className="tile-related-blog">
                <h2 className="title">Related Blogs</h2>
                <div className="designpage-relatedpost-row">
                  <Slider {...settings}>
                    {relatedBlogData?.map((obj, index) => {
                      return (
                        <div className="related-blog-col" key={index}>
                          <div className="blog-figure">
                            <a href={obj.permalink}>
                              <img
                                src={obj.image}
                                loading="lazy"
                                alt={obj.title}
                              />
                            </a>
                          </div>
                          <div className="blog-text">
                            <div className="listingDate">{obj.date}</div>
                            <div className="listingHead">
                              <a href={obj.permalink}>
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: obj.title,
                                  }}
                                />
                              </a>
                            </div>
                            <div className="listingText">
                              <p>
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: obj.content.slice(0, -11),
                                  }}
                                />
                              </p>
                              <div className="listingButton">
                                <a href={obj.permalink}>Read More</a>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </Slider>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default OpenKitchen;
